import { render, staticRenderFns } from "./StationV1Event.vue?vue&type=template&id=507c8894&scoped=true&"
import script from "./StationV1Event.vue?vue&type=script&lang=js&"
export * from "./StationV1Event.vue?vue&type=script&lang=js&"
import style0 from "./StationV1Event.vue?vue&type=style&index=0&id=507c8894&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c8894",
  null
  
)

/* custom blocks */
import block0 from "./StationV1Event.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507c8894')) {
      api.createRecord('507c8894', component.options)
    } else {
      api.reload('507c8894', component.options)
    }
    module.hot.accept("./StationV1Event.vue?vue&type=template&id=507c8894&scoped=true&", function () {
      api.rerender('507c8894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StationEvent/StationV1Event.vue"
export default component.exports